import styled from 'styled-components';
import { layout } from 'src/components/base';

export const PopularSearches = styled.div`
  padding: 0 ${layout.measurements.spacing050} 0;
  margin-bottom: ${layout.measurements.spacing100};
  display: flex;
  flex-wrap: wrap;
  gap: ${layout.measurements.spacing050};
`;
